// extracted by mini-css-extract-plugin
module.exports = {"container":"DocumentsCenter-module__container--1jGRs","content":"DocumentsCenter-module__content--22tHP","documents":"DocumentsCenter-module__documents--g2IEa"};